'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function initialize() {
    // Setup namespace for feed postmessages
    window.POSTMSG = window.POSTMSG || {};
    window.POSTMSG.feed = window.POSTMSG.feed || {};
    window.onmessage = function onmessage(e) {
        try {
            // No safeframe feed
            if (e && e.data && e.data === "feed" && window.FINN.banner.feed) {
                if (e.source) {
                    e.source.postMessage(window.FINN.banner.feed, "*");
                }
            }
            // Safeframe feed
            if (e.data) {
                if (e.data.feed &&
                    e.data.feed.action &&
                    e.data.feed.action === "request") {
                    if (window.FINN &&
                        window.FINN.banner &&
                        window.FINN.banner.feed) {
                        window.POSTMSG.feed.params = window.FINN.banner.feed;
                    }
                    window.POSTMSG.feed.action = "response";
                    if (e.source) {
                        e.source.postMessage(window.POSTMSG, "*");
                    }
                }
            }
        }
        catch (error) {
            console.error("Error in reply to feed postMessage", error);
        }
    };
}

exports.initialize = initialize;
//# sourceMappingURL=index.js.map
